module.exports = __webpack_public_path__ + "static/media/dagger-legendary.81ffc705.png";